export default __webpack_public_path__ + "static/media/icon-coin-arkm.08b456df.svg";